// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MinimizeView__container-ddfcf7 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  flex: 1 1 auto;
  width: 296px;
  min-height: 150px;
  max-height: 296px;
  position: absolute;
  top: 96px;
  inset-inline-end: 24px;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  z-index: 1;
  border-radius: 16px;
}

.MinimizeView__container-ddfcf7 video {
  object-fit: cover !important;
  position: static !important;
}

.MinimizeView__dragging-ac5ee7 * {
  pointer-events: none;
}

.MinimizeView__button-cbaea2 {
  margin: 0 12px;
}

.MinimizeView__expand-abcd5e {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  opacity: 0;
}

.MinimizeView__container-ddfcf7.MinimizeView__show-controls-c022a3 .MinimizeView__expand-abcd5e {
  opacity: 1;
}

.MinimizeView__container-ddfcf7:hover .MinimizeView__expand-abcd5e {
  opacity: 1;
}

.MinimizeView__live-c807fe {
  position: absolute;
  inset-inline-start: 8px;
  top: 8px;
  background-color: var(--addition-160);
  border-radius: 8px;
  padding: 6px 7px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/ParticipantView/MinimizeView/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,2BAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: stretch;\n  flex: 1 1 auto;\n  width: 296px;\n  min-height: 150px;\n  max-height: 296px;\n  position: absolute;\n  top: 96px;\n  inset-inline-end: 24px;\n  overflow: hidden;\n  cursor: pointer;\n  box-sizing: border-box;\n  z-index: 1;\n  border-radius: 16px;\n}\n\n.container video {\n  object-fit: cover !important;\n  position: static !important;\n}\n\n.dragging * {\n  pointer-events: none;\n}\n\n.button {\n  margin: 0 12px;\n}\n\n.expand {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 8px;\n  opacity: 0;\n}\n\n.container.show-controls .expand {\n  opacity: 1;\n}\n\n.container:hover .expand {\n  opacity: 1;\n}\n\n.live {\n  position: absolute;\n  inset-inline-start: 8px;\n  top: 8px;\n  background-color: var(--addition-160);\n  border-radius: 8px;\n  padding: 6px 7px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MinimizeView__container-ddfcf7`,
	"dragging": `MinimizeView__dragging-ac5ee7`,
	"button": `MinimizeView__button-cbaea2`,
	"expand": `MinimizeView__expand-abcd5e`,
	"show-controls": `MinimizeView__show-controls-c022a3`,
	"showControls": `MinimizeView__show-controls-c022a3`,
	"live": `MinimizeView__live-c807fe`
};
module.exports = ___CSS_LOADER_EXPORT___;
